import React from 'react';

const ReviewForm = ({
  ratings,
  onRatingChange,
  averageRating,
  reviewComment,
  setReviewComment,
  onSubmitReview,
  onSkip,
  loading
}) => {
  const ratingCategories = [
    {
      key: 'service_quality',
      label: 'Service Quality',
      icon: '🎯',
      description: 'Was the work done properly and professionally?'
    },
    {
      key: 'timeliness',
      label: 'Timeliness',
      icon: '⏰',
      description: 'Did they arrive and finish on time?'
    },
    {
      key: 'attitude',
      label: 'Attitude',
      icon: '😊',
      description: 'Were they polite, friendly, and professional?'
    },
    {
      key: 'value_for_money',
      label: 'Value for Money',
      icon: '💰',
      description: 'Was the service worth the price?'
    }
  ];

  return (
    <div className="space-y-4">
      <h4 className="font-semibold text-center text-lg">Rate Your Experience</h4>
      <p className="text-center text-sm text-gray-500 mb-4">
        Please rate the provider on each of the following criteria
      </p>
      
      {/* Rating Categories */}
      <div className="space-y-4">
        {ratingCategories.map((category) => (
          <div key={category.key} className="bg-gray-50 p-3 rounded-lg">
            <div className="flex justify-between items-center mb-2">
              <span className="font-medium text-gray-700">{category.icon} {category.label}</span>
              <span className="text-sm text-gray-500">{ratings[category.key]}/5</span>
            </div>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onClick={() => onRatingChange(category.key, star)}
                  className={`text-2xl transition-transform hover:scale-110 ${star <= ratings[category.key] ? 'text-yellow-400' : 'text-gray-300'}`}
                  data-testid={`rating-${category.key}-${star}`}
                >
                  ★
                </button>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-1">{category.description}</p>
          </div>
        ))}
      </div>

      {/* Average Rating Display */}
      <div className="bg-orange-50 p-4 rounded-lg text-center border border-orange-200">
        <p className="text-sm text-gray-600 mb-1">Overall Rating</p>
        <div className="flex items-center justify-center gap-2">
          <span className="text-3xl text-yellow-400">★</span>
          <span className="text-3xl font-bold text-orange-600">{averageRating.toFixed(1)}</span>
          <span className="text-gray-500">/ 5</span>
        </div>
      </div>

      <textarea
        value={reviewComment}
        onChange={(e) => setReviewComment(e.target.value)}
        placeholder="Share your experience with this service provider... (optional)"
        rows="3"
        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        data-testid="review-comment"
      />

      <button
        onClick={onSubmitReview}
        disabled={loading}
        className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-lg hover:shadow-lg font-semibold disabled:opacity-50"
        data-testid="submit-review-btn"
      >
        {loading ? 'Submitting...' : 'Submit Review'}
      </button>

      <button
        onClick={onSkip}
        className="w-full text-gray-500 hover:text-gray-700"
      >
        Skip for now
      </button>
    </div>
  );
};

export default ReviewForm;
